function initScrollSlider( node, gsap, ScrollTrigger ) {
	const track = node.querySelector( '.scroll-slider__track' );
	const container = node.querySelector( '.scroll-slider__container' );

	if ( ! track || ! container ) {
		return;
	}

	// Disable scroll-behavior: smooth which can cause issues with ScrollTrigger
	document.documentElement.style.scrollBehavior = 'auto';

	// If this block is inside a GSAP-pinned container (e.g. .entry-content
	// pinned by the hero block), the trigger positions must account for that
	// pin's extra scroll distance.
	const pinnedContainer = node.closest( '.entry-content' ) || null;

	gsap.to( track, {
		x: () => -( track.scrollWidth - container.offsetWidth ),
		ease: 'none',
		scrollTrigger: {
			trigger: node,
			pinnedContainer,
			start: 'top bottom',
			end: 'bottom top',
			scrub: true,
			invalidateOnRefresh: true,
		},
	} );
}

function init( node ) {
	if ( ! ( node instanceof HTMLElement ) ) {
		return;
	}

	const { gsap } = window;
	if ( ! gsap ) {
		console.warn( 'GSAP not available. Make sure gsap and gsap-scroll-trigger are enqueued.' );
		return;
	}

	// ScrollTrigger registers itself with GSAP when loaded
	const ScrollTrigger = gsap.ScrollTrigger || window.ScrollTrigger;
	if ( ! ScrollTrigger ) {
		console.warn( 'ScrollTrigger not available. Make sure gsap-scroll-trigger is enqueued after gsap.' );
		return;
	}

	initScrollSlider( node, gsap, ScrollTrigger );
}

/**
 * Initialize scroll-slider blocks.
 *
 * We listen for 'poh:scroll-setup-done', a custom event dispatched by the
 * hero block after it has created its pin trigger and called
 * ScrollTrigger.refresh(). This ensures scroll positions are correct on the
 * first calculation rather than needing a subsequent refresh to correct them.
 *
 * If no hero is present on the page the event never fires, so we fall back
 * to window 'load', which also runs after all defer scripts have executed.
 */
const initScrollSliders = () => {
	const sliderElements = document.querySelectorAll( '.scroll-slider' );
	if ( sliderElements.length > 0 ) {
		sliderElements.forEach( ( element ) => {
			init( element );
		} );
	}
};

// One-shot handler — whichever event fires first wins; the other is ignored.
let initialized = false;
const onReady = () => {
	if ( initialized ) {
		return;
	}
	initialized = true;
	initScrollSliders();
};

document.addEventListener( 'poh:scroll-setup-done', onReady );

if ( document.readyState === 'complete' ) {
	onReady();
} else {
	window.addEventListener( 'load', onReady );
}
